import { useNavigate, Link } from 'react-router-dom';
import { Lock, FileText, CloudUpload, Database, Rocket, Infinity } from 'lucide-react';
import styles from './styles.module.css';

const PLANS = [
    {
        id: 'free',
        name: 'Gratuito',
        price: 'R$ 0',
        period: '/mês',
        notes: '4 notas/mês',
        highlight: false,
        benefits: [],
    },
    {
        id: 'plus',
        name: 'Plus',
        price: 'R$ 12,90',
        period: '/mês',
        notes: '20 notas/mês',
        highlight: true,
        benefits: [
            { icon: <FileText size={14} />, text: '20 notas por mês' },
            { icon: <CloudUpload size={14} />, text: 'Backup automático' },
            { icon: <Database size={14} />, text: 'Mais armazenamento' },
        ],
    },
    {
        id: 'premium',
        name: 'Premium',
        price: 'R$ 21,90',
        period: '/mês',
        notes: 'Ilimitado',
        highlight: false,
        benefits: [
            { icon: <Infinity size={14} />, text: 'Notas ilimitadas' },
            { icon: <Rocket size={14} />, text: 'Recursos premium' },
            { icon: <Database size={14} />, text: 'Armazenamento máximo' },
        ],
    },
];

export default function UpgradeModal({ currentPlan, setOpenUpgradeModal }) {
    const navigate = useNavigate();

    const currentIndex = PLANS.findIndex((p) => p.id === currentPlan);
    const nextPlan = PLANS[currentIndex + 1];
    const current = PLANS[currentIndex];

    // Se já é premium (sem próximo plano), só fecha
    if (!nextPlan) {
        setOpenUpgradeModal(false);
        return null;
    }

    return (
        <div className={styles.overlay} onClick={() => setOpenUpgradeModal(false)}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.iconWrap}>
                        <Lock size={20} />
                    </div>
                    <span className={styles.badge}>Limite atingido</span>
                    <h2 className={styles.title}>
                        Você está no plano{' '}
                        <span className={styles.planName}>{current.name}</span>
                    </h2>
                    <p className={styles.subtitle}>
                        Chegou ao limite de {current.notes}. Faça upgrade para continuar.
                    </p>
                </div>

                {/* Card do próximo plano */}
                <div className={styles.body}>
                    <p className={styles.sectionLabel}>Próximo plano</p>

                    <div className={`${styles.planCard} ${nextPlan.highlight ? styles.planHighlight : ''}`}>
                        {nextPlan.highlight && (
                            <span className={styles.planBadge}>Mais popular</span>
                        )}

                        <div className={styles.planHeader}>
                            <span className={styles.planCardName}>{nextPlan.name}</span>
                            <div className={styles.planPriceWrap}>
                                <span className={styles.planPrice}>{nextPlan.price}</span>
                                <span className={styles.planPeriod}>{nextPlan.period}</span>
                            </div>
                        </div>

                        <ul className={styles.benefitsList}>
                            {nextPlan.benefits.map((b, i) => (
                                <li key={i} className={styles.benefitItem}>
                                    <span className={styles.benefitIcon}>{b.icon}</span>
                                    {b.text}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Botões */}
                <div className={styles.actions}>
                    <button
                        className={styles.cancelBtn}
                        onClick={() => setOpenUpgradeModal(false)}
                    >
                        Agora não
                    </button>
                    <button
                        className={styles.upgradeBtn}
                        // Por isso:
                        onClick={() => {
                            setOpenUpgradeModal(false);
                            navigate('/planos');
                        }}
                    >
                        <Rocket size={14} />
                        Fazer upgrade para {nextPlan.name}
                    </button>
                </div>

                {/* Link para página de planos */}
                <div className={styles.footer}>
                    <span>Ver todos os planos em </span>
                    <Link to="/planos" className={styles.footerLink} onClick={() => setOpenUpgradeModal(false)}>
                        /planos →
                    </Link>
                </div>

            </div>
        </div>
    );
}